module.exports = __webpack_public_path__ + "static/media/Seam_4631.a268f8cb.jpg";